import PropTypes from 'prop-types';

import {
  Box,
} from '@mui/material';
import { useStyles } from './style';

export const FormCardWrap = ({ children, cardsBgNumber = 0 }) => {
  const classes = useStyles();

  return (
    <Box className={classes.formCardWrap}>
      <Box className={classes.backgroundPages}>
        {
          (cardsBgNumber > 0) && [...Array(cardsBgNumber)].map((_, i) => <Box key={i} className={classes.backgroundPagesView} sx={{ width: `calc(100% - ${(cardsBgNumber - i) * 12}px)` }} />)
        }
      </Box>
      <Box className={classes.formCardContainer}>
        {children}
      </Box>
    </Box>
  );
};

FormCardWrap.propTypes = {
  children: PropTypes.element,
  cardsBgNumber: PropTypes.number
};

FormCardWrap.defaultProps = {
  children: null,
  cardsBgNumber: 0
};
